import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function CruisePurchaseGuestTable({
  parentIndex,
}: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name = `approvalable.cruisePurchases.${parentIndex}.cruisePurchaseGuests`;
  const value = HOCWatchValue({ keys: [name] });

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={value[name]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
